/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useUpdateStatusResourceStatisticsCountsQuery } from "~/generated/graphql";
import {
  ResourceUpdateStatus,
  type UpdateStatusCardItem,
} from "~/views/resources/ResourceUpdateStatus/types";

export function useGetResourceUpdateStatusCounts() {
  const {
    data: rawData,
    loading,
    error,
    refetch,
  } = useUpdateStatusResourceStatisticsCountsQuery();

  const counts = rawData?.updateStatusResourceStatisticsCounts || [];

  const mappedData: UpdateStatusCardItem[] = counts.map((item) => ({
    status: item.updateStatus as ResourceUpdateStatus,
    count: item.count,
  }));

  const total = mappedData.reduce((sum, { count }) => sum + count, 0);

  const data = [
    { status: ResourceUpdateStatus.Total, count: total },
    ...mappedData,
  ];

  return { data, loading, error, refetch } as const;
}
